module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel",
    staticStyle: {
      "margin": "0 -15px"
    }
  }, [_c('div', {
    staticClass: "summary-layout"
  }, [_c('table', {
    staticClass: "table table-fixed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.summaryData), function(data) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.medication.code))]), _c('td', [_vm._v(_vm._s(data.medication.CGMH_number))]), _c('td', [_vm._v(_vm._s(data.medication.generic_name))]), _c('td', [_vm._v(_vm._s(data.count))]), _c('td', [_vm._v(_vm._s(data.total))])])
  }), 0)])])]), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("藥碼")]), _c('th', [_vm._v("料位號")]), _c('th', [_vm._v("藥物名稱")]), _c('th', [_vm._v("藥盒數量")]), _c('th', [_vm._v("總數量")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01d0fa2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrugStorageSummary.vue
// module id = 1365
// module chunks = 1